// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"0c9c1325","119":"7425a347","126":"8c449d44","279":"699b260d","452":"39bd7234","777":"e8b63d96"}[chunkId] + ".chunk.js";
};